import { Link } from "react-router-dom";
import { LOGO_URL } from "./Navbar";

export default function Footer() {
  return (
    <footer className="bg-brand-graphite text-white/80 mt-20">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="mb-4">
            <img src={LOGO_URL} alt="PetMachine Hub" className="h-10 w-auto rounded-lg" />
          </div>
          <p className="text-sm text-white/60">O ecossistema inteligente de cuidado, serviços e tecnologia para o seu pet em Joinville-SC.</p>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3">Plataforma</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/prestadores" className="hover:text-brand-mint">Encontrar serviços</Link></li>
            <li><Link to="/loja" className="hover:text-brand-mint">Loja de Tags</Link></li>
            <li><Link to="/coleiras" className="hover:text-brand-mint">Coleiras</Link></li>
            <li><Link to="/aves" className="hover:text-brand-mint">Identificação para Aves</Link></li>
            <li><Link to="/testadores" className="hover:text-brand-mint">Área de Testadores</Link></li>
            <li><Link to="/planos" className="hover:text-brand-mint">PetHub Club</Link></li>
            <li><Link to="/pets-perdidos" className="hover:text-brand-mint">Pets desaparecidos</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3">Para Prestadores</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/cadastro?role=provider" className="hover:text-brand-mint">Cadastre seu negócio</Link></li>
            <li><Link to="/planos" className="hover:text-brand-mint">Planos e preços</Link></li>
            <li><span className="text-white/50">7 dias de teste grátis</span></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><span className="text-white/50">Termos de Uso</span></li>
            <li><Link to="/privacidade" className="hover:text-brand-mint" data-testid="footer-privacy-link">Política de Privacidade (LGPD)</Link></li>
            <li><Link to="/excluir-conta" className="hover:text-brand-mint" data-testid="footer-delete-link">Excluir conta e dados</Link></li>
            <li><span className="text-white/50">petmachinehub.com.br</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
        © 2026 PetMachine Hub — Joinville, Santa Catarina. Feito com tecnologia e amor pelos pets.
      </div>
    </footer>
  );
}
